/* UltraClean Pro — interactions UC3 partagées par toutes les pages :
   inclinaison 3D, galerie produit, compteurs, ajout panier + toast, filtres catalogue, révélations.
   Fonctionne sans GSAP ; s'en sert pour la finition quand il est là. */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var gsap = window.gsap;

  /* ------------------------------------------------------- révélations */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (en) {
    en.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -10% 0px' }) : null;
  $$('[data-uc3-reveal], [data-uc3-card]').forEach(function (el, i) {
    if (el.hasAttribute('data-uc3-card')) el.style.setProperty('--d', (i % 3) * 0.08 + 's');
    if (io) io.observe(el); else el.classList.add('is-in');
  });

  /* ---------------------------------------------------- inclinaison 3D */
  if (fine) {
    $$('[data-uc3-tilt]').forEach(function (el) {
      var raf = 0, tx = 0, ty = 0, x = 0, y = 0, on = false;
      function tick() {
        x += (tx - x) * 0.12; y += (ty - y) * 0.12;
        el.style.setProperty('--rx', (-y * 7).toFixed(2) + 'deg');
        el.style.setProperty('--ry', (x * 9).toFixed(2) + 'deg');
        el.style.setProperty('--mx', (50 + x * 50).toFixed(1) + '%');
        el.style.setProperty('--my', (50 + y * 50).toFixed(1) + '%');
        if (on || Math.abs(tx - x) + Math.abs(ty - y) > 0.002) raf = requestAnimationFrame(tick); else raf = 0;
      }
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        tx = (e.clientX - r.left) / r.width - 0.5;
        ty = (e.clientY - r.top) / r.height - 0.5;
        on = true; el.classList.add('is-tilt');
        if (!raf) raf = requestAnimationFrame(tick);
      });
      el.addEventListener('pointerleave', function () {
        tx = 0; ty = 0; on = false; el.classList.remove('is-tilt');
        if (!raf) raf = requestAnimationFrame(tick);
      });
    });
  }

  /* ---------------------------------------------------- galerie produit */
  $$('[data-uc3-gallery]').forEach(function (g) {
    var slides = $$('[data-uc3-slide]', g), thumbs = $$('[data-uc3-thumb]', g), cur = 0;
    if (slides.length < 2) return;
    function go(i) {
      i = (i + slides.length) % slides.length;
      if (i === cur) return;
      var dir = i > cur ? 1 : -1, prev = slides[cur], next = slides[i];
      cur = i;
      slides.forEach(function (s) { s.classList.remove('is-on', 'is-out'); });
      prev.classList.add('is-out');
      next.classList.add('is-on');
      if (gsap) {
        gsap.fromTo(next, { clipPath: dir > 0 ? 'inset(0 0 0 100%)' : 'inset(0 100% 0 0)' }, { clipPath: 'inset(0 0% 0 0%)', duration: 1.1, ease: 'expo.inOut' });
        gsap.fromTo($('img', next), { scale: 1.18, xPercent: dir * 6 }, { scale: 1, xPercent: 0, duration: 1.4, ease: 'expo.out' });
      }
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); t.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.dataset.uc3Thumb); }); });
    /* glisser pour changer de photo (tactile et souris) */
    var card = $('.uc3-p__card', g), sx = null;
    card.addEventListener('pointerdown', function (e) { sx = e.clientX; });
    window.addEventListener('pointerup', function (e) {
      if (sx === null) return;
      var dx = e.clientX - sx; sx = null;
      if (Math.abs(dx) > 50) go(cur + (dx < 0 ? 1 : -1));
    });
    card.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') go(cur + 1); if (e.key === 'ArrowLeft') go(cur - 1); });
  });

  /* ------------------------------------------------------- compteurs */
  $$('[data-uc3-count]').forEach(function (el) {
    var to = parseFloat(el.dataset.uc3Count);
    if (!isFinite(to)) return;
    var dec = String(el.dataset.uc3Count).indexOf('.') > -1 ? 1 : 0;
    var done = false;
    var show = function (v) { el.textContent = v.toFixed(dec).replace('.', ','); };
    show(0);
    var ob = new IntersectionObserver(function (en) {
      if (!en[0].isIntersecting || done) return;
      done = true; ob.disconnect();
      var t0 = performance.now(), D = 1600;
      (function step(now) {
        var k = Math.min(1, (now - t0) / D);
        show(to * (1 - Math.pow(1 - k, 4)));
        if (k < 1) requestAnimationFrame(step);
      })(t0);
    }, { threshold: 0.4 });
    ob.observe(el);
  });

  /* ------------------------------------------------ quantité & variantes */
  $$('[data-uc3-qty]').forEach(function (q) {
    var input = $('input', q), b = $$('button', q);
    b[0].addEventListener('click', function () { input.value = Math.max(1, (+input.value || 1) - 1); });
    b[1].addEventListener('click', function () { input.value = Math.min(20, (+input.value || 1) + 1); });
  });
  $$('[data-uc3-form] input[type="radio"][name="id"]').forEach(function (r) {
    r.addEventListener('change', function () {
      var p = $('[data-uc3-price]');
      if (p && r.dataset.price) p.textContent = r.dataset.price;
    });
  });

  /* ------------------------------------------------ ajout panier + toast */
  var toast = $('[data-uc3-toast]');
  var toastTimer = 0;
  function showToast(title) {
    if (!toast) return;
    $('[data-uc3-toast-title]', toast).textContent = title;
    toast.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('is-on'); }, 6000);
  }
  if (toast) $('[data-uc3-toast-close]', toast).addEventListener('click', function () { toast.classList.remove('is-on'); });

  $$('[data-uc3-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      var btn = $('button[type="submit"]', form), label = $('[data-uc3-cta-label]', form), txt = label ? label.textContent : '';
      btn.disabled = true;
      if (label) label.textContent = 'Ajout…';
      fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
        .then(function (r) { if (!r.ok) throw r; return fetch('/cart.js'); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          $$('[data-uc2-cart-count]').forEach(function (n) { n.textContent = cart.item_count; });
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          if (label) label.textContent = 'Ajouté ✓';
          showToast(form.dataset.title || '');
          var cartLink = $('[data-uc2-cart]');
          if (cartLink && gsap) gsap.fromTo(cartLink, { scale: 1.3 }, { scale: 1, duration: 0.9, ease: 'elastic.out(1, 0.4)' });
        })
        .catch(function () { if (label) label.textContent = 'Indisponible'; })
        .then(function () { setTimeout(function () { btn.disabled = false; if (label) label.textContent = txt; }, 2200); });
    });
  });

  /* ------------------------------------------------- filtres catalogue */
  $$('[data-uc3-coll]').forEach(function (sec) {
    var grid = $('[data-uc3-grid]', sec), cards = $$('[data-uc3-card]', grid), none = $('[data-uc3-none]', sec);
    var original = cards.slice(), filter = 'all', sort = 'default';
    function apply() {
      var lo = 0, hi = 1e9;
      if (filter !== 'all') { var p = filter.split('-'); lo = +p[0]; hi = +p[1]; }
      var list = original.slice();
      if (sort === 'price-asc') list.sort(function (a, b) { return pr(a) - pr(b); });
      if (sort === 'price-desc') list.sort(function (a, b) { return pr(b) - pr(a); });
      if (sort === 'vol-asc') list.sort(function (a, b) { return (+a.dataset.vol || 999) - (+b.dataset.vol || 999); });
      /* FLIP maison : on mémorise, on réordonne, on anime l'écart */
      var first = new Map();
      cards.forEach(function (c) { first.set(c, c.getBoundingClientRect()); });
      var shown = 0;
      list.forEach(function (c) {
        var v = +c.dataset.vol || 0;
        var on = filter === 'all' || (v >= lo && v <= hi);
        c.hidden = !on;
        if (on) shown++;
        grid.appendChild(c);
      });
      if (none) none.hidden = shown > 0;
      list.forEach(function (c) {
        if (c.hidden) return;
        var a = first.get(c), b = c.getBoundingClientRect();
        if (!a || !a.width) { c.animate([{ opacity: 0, transform: 'translateY(30px) scale(.96)' }, { opacity: 1, transform: 'none' }], { duration: 700, easing: 'cubic-bezier(.16,1,.3,1)' }); return; }
        var dx = a.left - b.left, dy = a.top - b.top;
        if (dx || dy) c.animate([{ transform: 'translate(' + dx + 'px,' + dy + 'px)' }, { transform: 'none' }], { duration: 800, easing: 'cubic-bezier(.16,1,.3,1)' });
      });
      if (window.ScrollTrigger) window.ScrollTrigger.refresh();
    }
    function pr(c) { var v = +c.dataset.price; return v === 0 ? 1e12 : v; }
    $$('[data-uc3-filter]', sec).forEach(function (b) {
      b.addEventListener('click', function () {
        filter = b.dataset.uc3Filter;
        $$('.uc3-chip', sec).forEach(function (c) { c.classList.toggle('is-on', c.dataset.uc3Filter === filter); });
        apply();
      });
    });
    var sel = $('[data-uc3-sort]', sec);
    if (sel) sel.addEventListener('change', function () { sort = sel.value; apply(); });
  });

  /* ----------------------------------- parallaxe des images (avec GSAP) */
  function parallax() {
    var g = window.gsap, ST = window.ScrollTrigger;
    if (!g || !ST) return;
    g.registerPlugin(ST);
    $$('.uc3-p__card').forEach(function (card) {
      g.fromTo(card, { y: 0 }, { y: -40, ease: 'none', scrollTrigger: { trigger: card, start: 'top 30%', end: 'bottom top', scrub: true } });
    });
    $$('.uc3-pd__body p:first-child').forEach(function (p) {
      g.fromTo(p, { backgroundSize: '0% 100%' }, { backgroundSize: '100% 100%', ease: 'none', scrollTrigger: { trigger: p, start: 'top 80%', end: 'bottom 50%', scrub: true } });
    });
  }
  if (window.gsap) parallax(); else window.addEventListener('load', parallax);
})();
